export default "__VITE_ASSET__CFet3BZY__"